import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * Fetches audit logs for a specific Vendor Invoice Management invoice
 * @param {string|number} invoiceId - The invoice id
 * @returns {Promise} - API response containing audit logs
 */
export const getPOInvoiceAuditLogs = async (invoiceId) => {
  try {
    const response = await apiClient.get(`/adminInvoiceManagement/invoice/audit-logs/${invoiceId}`);

    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
